var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.97 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fec213;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "connect-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plug-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    "data-name": "Vector 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    "data-name": "path0 fill",
    className: "cls-1",
    d: "M9.2,19.27V3l3.85-1.8,9.86,4.57,1.32,7-5.17,7.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "plug-right-2",
    "data-name": "plug-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    "data-name": "path1 fill",
    className: "cls-2",
    d: "M42,11A1.92,1.92,0,0,0,40,9.08H27.47A11,11,0,0,0,16.64,0H9A1.92,1.92,0,0,0,7.05,1.92V20.08A1.92,1.92,0,0,0,9,22h7.67a11,11,0,0,0,10.82-9.08H40A1.92,1.92,0,0,0,42,11ZM16.64,18.16H10.89V3.84h5.75a7.16,7.16,0,0,1,0,14.32Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectRight);
export default __webpack_public_path__ + "static/media/connect-right.afc3bafb14bb2d5a4dd360426b3caa79.svg";
export { ForwardRef as ReactComponent };